import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=3870dc56"
import script from "./uploadImg.vue?vue&type=script&lang=js"
export * from "./uploadImg.vue?vue&type=script&lang=js"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=3870dc56&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3870dc56')) {
      api.createRecord('3870dc56', component.options)
    } else {
      api.reload('3870dc56', component.options)
    }
    module.hot.accept("./uploadImg.vue?vue&type=template&id=3870dc56", function () {
      api.rerender('3870dc56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadImg/uploadImg.vue"
export default component.exports